import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { ATTRIBUTES } from "../../data/adminData";
import { PageTitle, Card, Btn } from "./ui";

export default function Attributes() {
  const [list, setList] = useState(ATTRIBUTES.map((a) => ({ ...a, values: [...a.values] })));
  const [inputs, setInputs] = useState({});
  const addVal = (id) => {
    const v = (inputs[id] || "").trim();
    if (!v) return;
    setList((p) => p.map((a) => (a.id === id ? { ...a, values: [...a.values, v] } : a)));
    setInputs((p) => ({ ...p, [id]: "" }));
    toast.success("Vērtība pievienota (DEMO)");
  };
  const delVal = (id, v) => setList((p) => p.map((a) => (a.id === id ? { ...a, values: a.values.filter((x) => x !== v) } : a)));

  return (
    <div data-testid="admin-attributes">
      <PageTitle>Atribūti un varianti ({list.length})</PageTitle>
      <div className="space-y-4">
        {list.map((a) => (
          <Card key={a.id} className="p-5" data-testid={`attribute-${a.id}`}>
            <div className="flex items-center gap-3 mb-3">
              <span className="font-extrabold">{a.name}</span>
              <span className="text-xs text-[#6B6B6B] bg-[#F5F5F5] px-2 py-0.5">{a.type}</span>
              <span className="text-xs text-[#6B6B6B]">{a.values.length} vērtības</span>
            </div>
            <div className="flex flex-wrap gap-2 mb-3">
              {a.values.map((v) => (
                <span key={v} className="flex items-center gap-1.5 text-xs font-semibold bg-[#F5F5F5] px-3 py-1.5">
                  {v}
                  <button onClick={() => delVal(a.id, v)} className="text-[#D0121A]" aria-label={`Dzēst ${v}`}><Trash2 size={11} /></button>
                </span>
              ))}
            </div>
            <div className="flex gap-2 max-w-md">
              <input value={inputs[a.id] || ""} onChange={(e) => setInputs((p) => ({ ...p, [a.id]: e.target.value }))} placeholder="Jauna vērtība…" data-testid={`attr-input-${a.id}`}
                className="flex-1 h-9 px-3 border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
              <Btn onClick={() => addVal(a.id)} data-testid={`attr-add-${a.id}`} className="flex items-center gap-1"><Plus size={13} /> Pievienot</Btn>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
